import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { connect, useDispatch } from 'react-redux';
import { AppConfig, JWT } from '../../config';
import axios from 'axios';
import { CompanyAction, AlertAction, AuthAction } from '../../actions';
import { history } from '../../history';
import { Translate as t } from '../../config/Translate';
import { Loading } from '../../components/common/Loading';
import { interpolate } from '../../config/i18nInterpolate';

const CompanyDelete = ({ company, isUpdateRes, DeleteCompany, ClearUpdateResult }) => {

    const { companyId } = useParams();
    const dispatch = useDispatch();
    const [isLoading, setIsLoading] = useState(true);
    const [errors, setErrors] = useState([]);

    const [delCheckResult, setDelCheckResult] = useState({ userCount: 0, siteCount: 0, childCompanyCount: 0 });
    const [checkError, setCheckError] = useState(false);

    useEffect(() => {
        setIsLoading(true)
        if (company.companyId) {
            // BUG-176: JWT() 인증 헤더 누락 시 BE checkToken 이 401 → 전역 인터셉터가 로그아웃/로그인 리다이렉트.
            // AdminSiteDelete 와 동일하게 JWT() 첨부. (site 는 정상, company 만 누락돼 있던 회귀)
            axios.get(AppConfig.API_SERVER_PATH + '/company/getdelcheckinfo/' + company.companyId, JWT()).then((ret) => {
                setIsLoading(false)
                if (ret.data.status === "success") {
                    setDelCheckResult(ret.data.data);
                } else {
                    setCheckError(true);
                    console.warn('[AdminCompanyDelete] getdelcheckinfo non-success', { handler: 'AdminCompanyDelete.useEffect', target: company.companyId, reason: ret.data?.err?.message || ret.data?.errmsg || 'non-success' });
                    dispatch(AlertAction.ErrorMsg(t('common.message.delete.checkFailed')));
                }
            }).catch((err) => {
                setIsLoading(false);
                setCheckError(true);
                console.warn('[AdminCompanyDelete] getdelcheckinfo failed', { handler: 'AdminCompanyDelete.useEffect', target: company.companyId, reason: err?.message || String(err) });
                dispatch(AlertAction.ErrorMsg(t('common.message.delete.checkFailed')));
            });
        } else {
            // BUG-158: companyId 부재 시 fetch 없음 → 즉시 로딩 해제(isLoading 이 렌더 게이트이므로
            // else 없으면 무한 "Loading..." 노출). AdminSiteDelete 와 대칭.
            setIsLoading(false);
        }
    }, []);

    useEffect(() => {
        if (isUpdateRes) {
            ClearUpdateResult();
            // U-26: 삭제 후 목록으로 이동 ('삭제됨' 안내는 CompanyAction.DeleteCompany 가 이미 띄움)
            history.push('/Admin/AdminCompanyList');
        }
    }, [isUpdateRes]);

    const handleDeleteCompany = (e) => {
        DeleteCompany(company.companyId);
    }

    return (
        <>
            {isLoading && <Loading inline text={t('common.status.loading')} />}
            {!isLoading && checkError && (
                <div className="card bg-warning text-white">
                    <div className="card-header">
                        <div className="card-title">{t('common.label.warning')}</div>
                    </div>
                    <div className="card-body">
                        <h4>{t('common.message.delete.checkFailed')}</h4>
                        <p>{t('common.message.delete.checkFailedHint')}</p>
                    </div>
                </div>
            )}
            {!isLoading && !checkError && delCheckResult.userCount + delCheckResult.siteCount + delCheckResult.childCompanyCount > 0 && (
                <>
                    <div className="card bg-danger text-white">
                        <div className="card-header">{t('common.label.warning')}</div>
                        <div className="card-body">
                            <div className="card-title">
                                {interpolate(t('common.message.delete.cannotDelete'), { name: company?.name ?? "" })}
                            </div>
                        </div>
                        <ul className="listview simple-listview">
                            {delCheckResult.userCount > 0 &&
                                <li>
                                    {interpolate(t('company.delete.reasonUsers'), { name: company?.name ?? "", count: delCheckResult.userCount })}
                                </li>}
                            {delCheckResult.siteCount > 0 &&
                                <li>
                                    {interpolate(t('company.delete.reasonSites'), { name: company?.name ?? "", count: delCheckResult.siteCount })}
                                </li>}
                            {delCheckResult.childCompanyCount > 0 &&
                                <li>
                                    {interpolate(t('company.delete.reasonChildren'), { name: company?.name ?? "", count: delCheckResult.childCompanyCount })}
                                </li>}
                        </ul>
                    </div>
                </>
            )}
            {!isLoading && !checkError && delCheckResult.userCount + delCheckResult.siteCount + delCheckResult.childCompanyCount <= 0 && (
                <>
                    <div className="card bg-danger text-white">
                        <div className="card-header">
                            <div className="card-title">{t('common.label.warning')}</div>
                        </div>
                        <div className="card-body">
                            <h4>{t('common.message.delete.appliedImmediately')}</h4>
                            <p>{t('common.message.delete.irreversible')}</p>
                            <p>{t('common.message.confirm.delete')}</p>
                        </div>
                    </div>
                    <button className="btn btn-outline-danger" onClick={handleDeleteCompany}>{t('company.button.deleteCompany')}</button>
                </>
            )}
        </>
    );
};

const mapState = (state) => {
    const isUpdateRes = state.CompanyReducer.isUpdateRes;
    return { isUpdateRes };
}

const mapDispatch = dispatch => ({
    ClearUpdateResult: () => dispatch(CompanyAction.ClearUpdateResult()),
    DeleteCompany: (companyid) => dispatch(CompanyAction.DeleteCompany(companyid))
})

export default connect(mapState, mapDispatch)(CompanyDelete);